// extracted by mini-css-extract-plugin
module.exports = {"gridNavDesktop":"nav_gridNavDesktop__4OxRl","nav":"nav_nav__7WSAd"};